module.exports = __webpack_public_path__ + "media/images/shirakawa-symbol-d94ef6f1b44ace398b37e972443c79fc.jpg";